module.exports = "<a href=\"#\" class=\"aboutPageContactHeader\">\n    {{contactType}}\n</a>\n<div class=\"aboutPageContactContent\">\n    {{contactDescription}}\n</div>"


//////////////////
// WEBPACK FOOTER
// /home/ppeters/filmCritClient/src/app/components/contactForm/contactForm.component.html
// module id = ../../../../../src/app/components/contactForm/contactForm.component.html
// module chunks = main